// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert {
  display: flex;
  flex-flow: wrap;
  gap: calc(.5rem);
  align-items: center;
  padding: calc(.5rem);
  border-radius: 0.25rem;
}

.alert .alert__icon {
    align-self: start;
  }

.alert .alert__message {
    font-size: 0.875rem;
    line-height: 1.375rem;
    flex: 1;
    overflow: auto;
    overflow-wrap: break-word;
  }

.alert--general {
    background-color: #f6f7f8;
  }

.alert--general .alert__icon {
    color: #707070;
  }

.alert--info {
    background-color: #e5f5ff;
  }

.alert--info .alert__icon {
    color: #206dd2;
  }

.alert--success {
    background-color: #e7f3e2;
  }

.alert--success .alert__icon {
    color: #428629;
  }

.alert--warning {
    background-color: #ffede0;
  }

.alert--warning .alert__icon {
    color: #db6b16;
  }

.alert--error {
    background-color: #fdeae9;
  }

.alert--error .alert__icon {
    color: #dd201d;
  }

.alert--constrain-width {
    width: fit-content;
  }
:host .alert--markdown ::ng-deep > .alert__message > :last-child {
    margin-bottom: 0;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
